import { v4 as uuidv4 } from "uuid";
import { ApplicationLookup, DeviceOS, DeviceType } from "../models/Enums";
import { MobileInformation } from "../models/MobileInformation";
import { isRemoteControl } from "./assessment-control";

declare var Android: any;
export declare var window: any;

var userAgent = window.navigator.userAgent.toLowerCase();
var safari = /safari/.test(userAgent);
let ios =
  /iPad|iPhone|iPod/.test(navigator.platform) ||
  (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

export function GetOSId() {
  if (typeof Android != "undefined") {
    return ApplicationLookup.Android;
  } else if (ios) {
    if (!safari) {
      return ApplicationLookup.iOS;
    }
  } else {
    return ApplicationLookup.Desktop;
  }
}
export function GetDeviceType() {
  if (isMobileDevice()) {
    return DeviceType.Mobile;
  } else if (isTabletDevice()) {
    return DeviceType.Tablet;
  } else if (isDesktopDevice()) {
    return DeviceType.Desktop;
  } else {
    return DeviceType.None;
  }
}
export function isMobileDevice(): boolean {
  // Check if the screen width is less than a certain threshold (e.g., 768 pixels)
  const isSmallScreen = window.innerWidth < 768;

  // Check if the user agent contains keywords commonly found in mobile devices
  const isMobileUserAgent =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );

  // Combine the conditions to determine if it's a mobile device
  return isSmallScreen || isMobileUserAgent;
}

export function isTabletDevice(): boolean {
  // Check if the screen width is within a certain range (e.g., between 768 and 1024 pixels)
  const isTabletScreen = window.innerWidth >= 768 && window.innerWidth < 1024;

  // Check if the user agent contains keywords commonly found in tablets
  const isTabletUserAgent = /iPad|Android|Tablet/i.test(navigator.userAgent);

  // Combine the conditions to determine if it's a tablet device
  return isTabletScreen || isTabletUserAgent;
}

export function isDesktopDevice(): boolean {
  // Check if the screen width is greater than or equal to a certain threshold (e.g., 1024 pixels)
  const isLargeScreen = window.innerWidth >= 1024;

  // Check if it's not a mobile or tablet device
  const isNotMobileOrTablet = !isMobileDevice() && !isTabletDevice();

  // Combine the conditions to determine if it's a desktop device
  return isLargeScreen && isNotMobileOrTablet;
}

export function CheckIfPhoneIsMute() {
  try {
    if (typeof Android != "undefined") {
      return Android.isMediaStreamMuted();
    } else if (ios) {
      if (!safari) {
        (window as any).webkit.messageHandlers.sendToIoS.postMessage({
          methodName: "setMediaStreamUnmuted",
        });
      }
    }
  } catch (error) {
    console.error(error);
  }
}

export function GetAppInformation() {
  try {
    if (typeof Android != "undefined") {
      const currDeviceInfo = Android.getDeviceInfo();
      localStorage.setItem("deviceInfo", currDeviceInfo);
      return currDeviceInfo;
    } else if (ios) {
      if (!safari) {
        (window as any).webkit.messageHandlers.sendToIoS.postMessage({
          methodName: "getDeviceInfo",
        });
        // (window as any).webkit.messageHandlers.sendToIoS.postMessage("getDeviceInfo");
        return "ios";
      }
    } else {
      let userAgent = window.navigator.userAgentData;
      let currDeviceInfo: MobileInformation = new MobileInformation();
      currDeviceInfo.oSType = userAgent.platform;

      currDeviceInfo.timeZone =
        Intl.DateTimeFormat().resolvedOptions().timeZone;
      // currDeviceInfo.webViewVersion = userAgent.brands[userAgent.brands.length - 1].version;
      currDeviceInfo.browser =
        userAgent?.brand !== undefined
          ? userAgent?.brands[userAgent?.brands.length - 1].brand +
            " " +
            userAgent?.brands[userAgent?.brands.length - 1].version
          : "0";
      currDeviceInfo.appVersion = localStorage.getItem("mobileUiVersion")!;

      localStorage.setItem("deviceInfo", JSON.stringify(currDeviceInfo));

      var nAgt = navigator.userAgent;
      let os = "";
      const clientStrings = [
        {
          s: "Windows 10",
          r: /(Windows 10.0|Windows NT 10.0)/,
        },
        {
          s: "Windows 8.1",
          r: /(Windows 8.1|Windows NT 6.3)/,
        },
        {
          s: "Windows 8",
          r: /(Windows 8|Windows NT 6.2)/,
        },
        {
          s: "Windows 7",
          r: /(Windows 7|Windows NT 6.1)/,
        },
        {
          s: "Windows Vista",
          r: /Windows NT 6.0/,
        },
        {
          s: "Windows Server 2003",
          r: /Windows NT 5.2/,
        },
        {
          s: "Windows XP",
          r: /(Windows NT 5.1|Windows XP)/,
        },
        {
          s: "Windows 2000",
          r: /(Windows NT 5.0|Windows 2000)/,
        },
        {
          s: "Windows ME",
          r: /(Win 9x 4.90|Windows ME)/,
        },
        {
          s: "Windows 98",
          r: /(Windows 98|Win98)/,
        },
        {
          s: "Windows 95",
          r: /(Windows 95|Win95|Windows_95)/,
        },
        {
          s: "Windows NT 4.0",
          r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/,
        },
        {
          s: "Windows CE",
          r: /Windows CE/,
        },
        {
          s: "Windows 3.11",
          r: /Win16/,
        },
        {
          s: "Android",
          r: /Android/,
        },
        {
          s: "Open BSD",
          r: /OpenBSD/,
        },
        {
          s: "Sun OS",
          r: /SunOS/,
        },
        {
          s: "Chrome OS",
          r: /CrOS/,
        },
        {
          s: "Linux",
          r: /(Linux|X11(?!.*CrOS))/,
        },
        {
          s: "iOS",
          r: /(iPhone|iPad|iPod)/,
        },
        {
          s: "Mac OS X",
          r: /Mac OS X/,
        },
        {
          s: "Mac OS",
          r: /(Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/,
        },
        {
          s: "QNX",
          r: /QNX/,
        },
        {
          s: "UNIX",
          r: /UNIX/,
        },
        {
          s: "BeOS",
          r: /BeOS/,
        },
        {
          s: "OS/2",
          r: /OS\/2/,
        },
        {
          s: "Search Bot",
          r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/,
        },
      ];

      for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
          currDeviceInfo.oSVersion = cs.s;
          break;
        }
      }
      localStorage.setItem("deviceInfo", JSON.stringify(currDeviceInfo));
      return currDeviceInfo;
    }
  } catch (error) {
    console.error(error);
  }
}

export function checkiOSCameraPermission() {
  try {
    if (ios) {
      if (!safari) {
        (window as any).webkit.messageHandlers.sendToIoS.postMessage({
          methodName: "checkiOSCameraPermission",
        });
      }
    }
  } catch (error) {
    console.error(error);
  }
}

export function startiOSVoiceListening() {
  console.log("startiOSVoiceListening called");
  // Remote control mode: the remote's START is the only start, so no voice commands
  if (isRemoteControl()) return;
  try {
    if (ios && !safari) {
      (window as any).webkit.messageHandlers.sendToIoS.postMessage({
        methodName: "startListening",
      });
    }
  } catch (error) {
    console.error("startListening failed", error);
  }
}

export function stopiOSVoiceListening() {
  console.log("stopiOSVoiceListening called");
  try {
    if (ios && !safari) {
      (window as any).webkit.messageHandlers.sendToIoS.postMessage({
        methodName: "stopListening",
      });
    }
  } catch (error) {
    console.error("stopListening failed", error);
  }
}

export function deviceUniqueId() {
  try {
    if (typeof Android != "undefined") {
      const data = Android.getDeviceUniqueId();
      localStorage.setItem("device_id", data);
      return data;
    } else if (ios && !safari) {
      // Native iOS replies asynchronously via window.HomeComponentReference.SetDeviceId
      (window as any).webkit.messageHandlers.sendToIoS.postMessage({
        methodName: "getDeviceUniqueId",
      });
      return undefined;
    } else {
      let webDeviceId = localStorage.getItem("device_id");
      if (!webDeviceId) {
        webDeviceId = uuidv4();
        localStorage.setItem("device_id", webDeviceId);
      }
      return webDeviceId;
    }
  } catch (error) {
    console.error(" failed getting device ID", error);
  }
}

//Generating PDF for mobile through Base 64 implementation
// export function printPdfForMobile(pdfFile: any) {
//   try {
//     if (typeof Android != "undefined") {
//       return Android.printBase64Pdf(pdfFile);
//     } else if (ios) {
//       if (!safari) {
//         (window as any).webkit.messageHandlers.sendToIoS.postMessage({
//           methodName: "printBase64Pdf",
//           pdfData: pdfFile,
//         });
//       }
//     }
//   } catch (error) {
//     console.error(error);
//   }
// }

//Generating PDF for mobile through link
export function printPdfForMobile(pdfFile: string) {
  try {
    if (typeof Android != "undefined") {
      return Android.printPDFFromURL(pdfFile);
    } else if (ios) {
      if (!safari) {
        (window as any).webkit.messageHandlers.sendToIoS.postMessage({
          methodName: "printPDFFromURL",
          getFileURL: pdfFile,
        });
      }
    }
  } catch (error) {
    console.error(error);
  }
}

export function unMuteAndIncreaseVolume() {
  debugger;
  console.log("unMuteAndIncreaseVolume");
  try {
    if (typeof Android != "undefined") {
      return Android.setMediaStreamUnmuted();
    } else if (ios) {
      if (!safari) {
        // (window as any).webkit.messageHandlers.sendToIoS.postMessage({ methodName: "isMediaStreamMuted" });
        (window as any).webkit.messageHandlers.sendToIoS.postMessage({
          methodName: "setMediaStreamUnmuted",
        });
      }
    }
  } catch (error) {
    console.error(error);
  }
}

export function CheckIfPhoneAngleAdjustmentExists() {
  try {
  } catch (error) {}
}

export function getAngleValues(start: boolean) {
  if (typeof Android != "undefined") {
    console.log("android angle function called");
    return Android.getAngelValues(start);
  } else if (ios) {
    if (!safari) {
      try {
        (window as any).webkit.messageHandlers.sendToIoS.postMessage({
          methodName: "getAngleValues",
          startStop: start,
        });
        //(window as any).webkit.messageHandlers.sendToIoS.getAngelValues.postMessage({});
        //(window as any).webkit.messageHandlers.sendToIoS.postMessage("getAngleValues");
      } catch (err) {
        console.log(err);
      }

      return "";
    }
  } else {
    return "";
  }
}

export function loadUnityScene(sceneToLoad: string) {
  try {
    if (typeof Android != "undefined") {
      return Android.loadUnityScene(sceneToLoad); // This is not actually implemented
    } else if (ios) {
      if (!safari) {
        (window as any).webkit.messageHandlers.sendToIoS.postMessage({
          methodName: "loadUnityScene",
          sceneName: sceneToLoad,
        });
      }
    }
  } catch (error) {
    console.error(error);
  }
}

// BLE remote (contract v1, docs/vstbalance-remote-integration-plan.md §4.4). Replies arrive in RemoteInputService.
function postRemoteMessage(message: { methodName: string; [key: string]: any }) {
  try {
    if (ios && !safari) {
      (window as any).webkit.messageHandlers.sendToIoS.postMessage(message);
    }
  } catch (error) {
    console.error(error);
  }
}

// Native replies with a "status" message. No reply means the native build doesn't support the remote.
export function requestRemoteStatus() {
  postRemoteMessage({ methodName: "getRemoteStatus" });
}

// Streams "scanResult" messages until stopped or ~30 s pass.
export function startRemoteScan() {
  postRemoteMessage({ methodName: "remoteStartScan" });
}

export function stopRemoteScan() {
  postRemoteMessage({ methodName: "remoteStopScan" });
}

// Pairs with a remote from the scan results and replaces any previously saved remote.
export function pairRemote(remoteId: string) {
  postRemoteMessage({ methodName: "remotePair", remoteId });
}

export function forgetRemote() {
  postRemoteMessage({ methodName: "remoteForget" });
}

export function logWebOnMobile(messageToLog: string) {
  try {
    if (typeof Android != "undefined") {
      return Android.logWebOnMobile(messageToLog); // This is not actually implemented
    } else if (ios) {
      if (!safari) {
        (window as any).webkit.messageHandlers.sendToIoS.postMessage({
          methodName: "logWebOnMobile",
          messageToLog: messageToLog,
        });
      }
    }
  } catch (error) {
    console.error(error);
  }
}
